import { useContext } from 'react';
import { Grid, Card, makeStyles, SvgIcon, Button } from '@material-ui/core';
import { ReactComponent as LinkIcon } from '../../../../assets/icons/link.svg';
import { ReactComponent as KeyIcon } from '../../../../assets/icons/key.svg';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { trackEvent } from '../../../../utils/eventTracking';
import { UserProfileContext } from '../../../../UserProfileContext';
import EditDataSpaceFormContext from '../../context/EditDataSpaceFormContext';

const useStyles = makeStyles((theme) => ({
	joinCard: {
		width: '15rem',
		padding: '1rem',
		marginBottom: '1rem',
		display: 'flex',
		flexDirection: 'column',
		'&:hover': {
			cursor: 'pointer',
		},
	},
	selectedJoinCard: {
		border: '2px solid gold',
	},
	headerWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	joinInfoLine: {
		marginBottom: '0.3rem',
		'& > svg': {
			marginRight: '0.4rem',
			verticalAlign: 'middle',
		},
	},
}));

// Card showing datasources and their join fields for a given join.
// One is rendered for each join to visualize the joins made.
const JoinCard = (props) => {
	const classes = useStyles();

	// User Profile Data
	const userProfile = useContext(UserProfileContext)[0];
	const editDataSpaceFormContext = useContext(EditDataSpaceFormContext);

	// If delete join button is clicked, delete the join from joinData.
	const deleteJoinButtonClickHandler = () => {
		editDataSpaceFormContext.setDataSpace((prevState) => {
			const updatedJoinData = prevState.joinData.map((dataset) => {
				const updatedJoins = dataset.joins.filter(
					(join) => ![join._id, join.foreignDatasetJoinId].includes(props.join._id),
				);

				return {
					...dataset,
					joins: updatedJoins,
				};
			});

			return {
				...prevState,
				joinData: updatedJoinData,
			};
		});

		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: {
				types: ['KissMetrics', 'Segment', 'Encharge', 'GA4'],
				eventName: 'Successfully Deleted a Join in Edit Dataspace Formm',
			},
		});
	};

	return (
		<Card
			key={props.join._id}
			className={classes.joinCard + (props.join.isSelected ? ' ' + classes.selectedJoinCard : '')}
		>
			<div className={classes.headerWrapper}>
				{props.dataset.displayName || props.dataset.name}
				<IconButton onClick={deleteJoinButtonClickHandler}>
					<DeleteIcon />
				</IconButton>
			</div>
			<div className={classes.joinInfoLine}>
				<SvgIcon>
					<KeyIcon />
				</SvgIcon>
				{props.join.primaryDataset.joinFieldDisplayName}
			</div>
			<div className={classes.joinInfoLine}>
				<SvgIcon>
					<LinkIcon />
				</SvgIcon>
				{props.dataset.displayName || props.dataset.name}
			</div>
			<div className={classes.joinInfoLine}>
				<SvgIcon>
					<KeyIcon />
				</SvgIcon>
				{props.join.foreignDataset.joinFieldDisplayName}
			</div>
		</Card>
	);
};

export default JoinCard;
